import FlexBox from '@sharedComponents/FlexBox';
import Typography from '@sharedComponents/Typography';
import { useTranslation } from 'react-i18next';

import OverrideBadge from '../OverrideBadge';

import * as style from './style.module.css';

/** Display of a row: "Hidden" in the error tone when `visible` is false, "Visible" otherwise. */
export const DisplayValue = ({ visible }) => {
    const { t } = useTranslation('bo');
    return visible === false ? (
        <Typography fontSize="s" color="error-primary">
            {t('Hidden')}
        </Typography>
    ) : (
        <Typography fontSize="s" color="neutral-secondary">
            {t('Visible')}
        </Typography>
    );
};

/** One value of a row, after its `label`; the other props go to its line. */
export const ValueLine = ({ label, children, ...props }) => (
    <FlexBox alignItems="center" gap="s" flexWrap="wrap" {...props}>
        <Typography fontSize="s" color="neutral-tertiary" className={style.valueLabel}>
            {label}
        </Typography>
        {children}
    </FlexBox>
);

/**
 * Values of an override `row`, in a frame: its title and its description with the badges of the table,
 * counted against the `total` catalogue languages, then its display unless `withDisplay` is false (a restricted
 * collection, where the visibility is the access). `header` comes before the values and `children` after them.
 */
const RowValues = ({ row, total, withDisplay = true, header = null, children = null }) => {
    const { t } = useTranslation('bo');
    return (
        <FlexBox flexDirection="column" gap="s" className={style.frame}>
            {header}
            <FlexBox flexDirection="column" gap="xs">
                <ValueLine label={t('Title')}>
                    <OverrideBadge text={row.title} total={total} />
                </ValueLine>
                <ValueLine label={t('Description')}>
                    <OverrideBadge text={row.description} total={total} />
                </ValueLine>
                {withDisplay && (
                    <ValueLine label={t('Display')}>
                        <DisplayValue visible={row.visible} />
                    </ValueLine>
                )}
            </FlexBox>
            {children}
        </FlexBox>
    );
};

export default RowValues;
